import { createTheme } from "@material-ui/core/styles";
// Create a theme instance.

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF3D00",
    },
    secondary: {
      main: "#6A45C4",
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: `'Montserrat', 'Helvetica', sans-serif`,
    button: {
      fontFamily: `'Space Grotesk', sans-serif`,
      fontWeight: "bolder",
    },
    h1: {
      fontFamily: `'Space Grotesk', sans-serif`,
      fontWeight: 700,
    },
    h2: {
      fontFamily: `'Space Grotesk', sans-serif`,
      fontWeight: 700,
    },
    h3: {
      fontFamily: `'Space Grotesk', sans-serif`,
      fontWeight: 700,
    },
    h4: {
      fontFamily: `'Space Grotesk', sans-serif`,
      fontWeight: 700,
    },
    h5: {
      fontFamily: `'Space Grotesk', sans-serif`,
      fontWeight: 700,
    },
    h6: {
      fontFamily: `'Space Grotesk', sans-serif`,
      fontWeight: 700,
    },
  },
});

export default theme;
